const api = {
    qualityItem: {
        query: '/api_proj/ProjProjectQualityItemAction/query',
        add: '/api_proj/ProjProjectQualityItemAction/add',
        update: '/api_proj/ProjProjectQualityItemAction/update',
        get: '/api_proj/ProjProjectQualityItemAction/getById',
        updateStatus: '/api_proj/ProjProjectQualityItemAction/updateStatus',
        delete: '/api_proj/ProjProjectQualityItemAction/delete',
        itemExcel: '/api_proj/ProjProjectQualityItemAction/itemExcel'
    },
    qualityTemplate: {
        query: '/api_proj/ProjProjectQualityTemplateAction/query',
        add: '/api_proj/ProjProjectQualityTemplateAction/add',
        update: '/api_proj/ProjProjectQualityTemplateAction/updateById',
        get: '/api_proj/ProjProjectQualityTemplateAction/getById',
        updateStatus: '/api_proj/ProjProjectQualityTemplateAction/updateStatus',
        copy: '/api_proj/ProjProjectQualityTemplateAction/copy',
        // delete: '/api_proj/ProjProjectQualityTemplateAction/delete'
    },
    qualityTemplateVersion: {
        query: '/api_proj/ProjProjectQualityTemplateVersionAction/query',
        list: '/api_proj/ProjProjectQualityTemplateVersionAction/list',
        add: '/api_proj/ProjProjectQualityTemplateVersionAction/add',
        update: '/api_proj/ProjProjectQualityTemplateVersionAction/update',
        get: '/api_proj/ProjProjectQualityTemplateVersionAction/getById',
        delete: '/api_proj/ProjProjectQualityTemplateVersionAction/deleteById'
    },
    qualityTemplateItem: {
        query: '/api_proj/ProjProjectQualityTemplateItemAction/query',
        update: '/api_proj/ProjProjectQualityTemplateItemAction/updateTemplateItemByItemId',
        delete: '/api_proj/ProjProjectQualityTemplateItemAction/deleteTemplateItemByItemId',
    },
    qualityTemplateConfig: {
        getAllCheckItem: '/api_proj/ProjProjectQualityItemAction/query',//获取全部的质检项
        getTemplateById: '/api_proj/ProjProjectQualityTemplateAction/getById',//获取质检表单详情
        updateTemplateById: '/api_proj/ProjProjectQualityTemplateAction/updateById',//修改质检表单分值，限值、环节
        addTemplateCategory: '/api_proj/ProjProjectQualityTemplateCategoryAction/add',//添加质检大类
        updateCategory: '/api_proj/ProjProjectQualityTemplateCategoryAction/updateTemplateCategory',//修改质检大类
        deleteCategory: '/api_proj/ProjProjectQualityTemplateCategoryAction/deleteById',//删除质检大类
        addCheckItem: '/api_proj/ProjProjectQualityTemplateItemAction/add',//添加质检大类质检项
        updateCheckItems: '/api_proj/ProjProjectQualityTemplateItemAction/update',//修改质检大类的质检项
        deleteCheckItems: '/api_proj/ProjProjectQualityTemplateItemAction/deleteById',//删除质检大类

    }
}

export default api;
